import supabase from '../supabase/supabase';

const GENERIC_AUTH_ERROR = 'Innlogging eller registrering kunne ikke fullføres. Kontroller opplysningene og prøv igjen.';

function emailConfirmationRedirect(token) {
  const redirect = new URL('/', window.location.origin);
  redirect.searchParams.set('academy_invite', token);
  redirect.hash = '/academy/activate';
  return redirect.toString();
}

function safeAuthError(error) {
  const message = String(error?.message || '').toLowerCase();

  if (message.includes('email not confirmed')) {
    return 'E-postadressen er ikke bekreftet. Åpne bekreftelseslenken før du logger inn.';
  }
  if (message.includes('already registered')) {
    return 'Det finnes allerede en konto med denne e-postadressen. Velg Logg inn.';
  }
  if (message.includes('password')) {
    return 'Passordet oppfyller ikke kravene. Kontroller passordet og prøv igjen.';
  }

  return GENERIC_AUTH_ERROR;
}

export async function registerAcademyInvitee(email, password, token) {
  const { data, error } = await supabase.auth.signUp({
    email: email.trim(),
    password,
    options: {
      emailRedirectTo: emailConfirmationRedirect(token)
    }
  });

  if (error) throw new Error(safeAuthError(error));

  return {
    user: data.user,
    confirmationRequired: !data.session
  };
}

export async function signInAcademyInvitee(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password
  });

  if (error) throw new Error(safeAuthError(error));
  if (!data.user || !data.session) {
    throw new Error('Innloggingen fullførte ikke. Prøv igjen.');
  }

  return data.user;
}

export async function acceptAcademyInvitation(token) {
  const { data, error } = await supabase.rpc(
    'hms_academy_invitation_accept_v1',
    { p_raw_token: token }
  );

  if (error) {
    const message = String(error.message || '').toLowerCase();

    if (message.includes('invalid or expired') || message.includes('does not match')) {
      throw new Error('Invitasjonen er ugyldig eller utløpt, eller e-postadressen samsvarer ikke med invitasjonen.');
    }
    if (message.includes('already linked')) {
      throw new Error('Deltakerkontoen er allerede knyttet til en annen bruker. Kontakt kursadministrator.');
    }
    if (message.includes('profile conflicts') || message.includes('organization')) {
      throw new Error('Brukerprofilen samsvarer ikke med invitasjonen. Kontakt kursadministrator.');
    }
    if (message.includes('exactly one') || message.includes('pending enrollment')) {
      throw new Error('Invitasjonen har ingen entydig ventende kurspåmelding. Kontakt kursadministrator.');
    }

    throw new Error('Invitasjonen kunne ikke aktiveres. Kontroller kontoen og prøv igjen.');
  }

  const result = Array.isArray(data) ? data[0] : data;
  if (!result?.accepted_learner_id || !result?.accepted_enrollment_id) {
    throw new Error('Aktiveringen kunne ikke bekreftes. Kontakt kursadministrator før du prøver igjen.');
  }

  return result;
}